import { WBFlex } from "@apptractive/design-system-web";
import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import { ReactNode } from "react";

export const PageContainer = ({
  children,
  sx = {},
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => {
  return (
    <WBFlex p={2} sx={{ flexDirection: "column", flex: 1, ...sx }}>
      {children}
    </WBFlex>
  );
};
